// src/utils/jwt.ts
interface UserData {
  email: string;
  nome: string;
  role: string[];
  firstLogin: boolean;
}

export function parseAuthToken(): UserData | null {
  const token = localStorage.getItem("@tlp-authToken");

  if (!token) return null;

  try {
    const [, payload] = token.split(".");
    const { nome, role, reset_password, sub } = JSON.parse(atob(payload));
    const roleArray = role
      .slice(1, -1)
      .split(",")
      .map((r: string) => r.trim());

    return {
      email: sub,
      nome,
      role: roleArray,
      firstLogin: reset_password,
    };
  } catch (error) {
    console.error("Erro ao decodificar token:", error);
    return null;
  }
}
